import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import Add from '@mui/icons-material/Add';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import classNames from 'classnames';

import { Button } from 'uikit/buttons';
import { Header } from 'uikit/layouts';
import { Menu } from 'uikit/menus';
import { Typo } from 'uikit/content';

import styles from '../styles/sectionHeader.module.scss';

const SectionHeader = ({
  title,
  addMenuItems = [],
  className = '',
  moreMenuItems = [],
  rightColumnChildren = null,
  shouldShowAddMenu = false,
  shouldShowMoreMenu = false,
  testId = '',
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const renderRightColumn = shouldShowMoreMenu ? (
    <div className={styles.rightColumn}>
      {rightColumnChildren}
      <Menu
        component={
          <Button
            ariaLabel={i18n.t('more')}
            className={styles.moreButton}
            icon={<MoreHoriz />}
            variant="ghost"
            size="xsmall"
          />
        }
        horizontalPosition="right"
        onIsOpenChange={({ isOpen }) => setIsMenuOpen(isOpen)}
      >
        {moreMenuItems}
      </Menu>
    </div>
  ) : (
    rightColumnChildren
  );

  return (
    <Header
      className={classNames(styles.element, className, {
        [styles.isMenuOpen]: isMenuOpen,
      })}
      leftColumn={
        <div className={styles.titleWrapper}>
          <Typo element="h2" variant="d01">
            {title}
          </Typo>
          {shouldShowAddMenu && (
            <Menu
              className={styles.addMenu}
              component={
                <Button ariaLabel={i18n.t('add')} icon={<Add />} variant="outlined" size="small" />
              }
              horizontalPosition="left"
            >
              {addMenuItems}
            </Menu>
          )}
        </div>
      }
      rightColumn={renderRightColumn}
      testId={testId}
    />
  );
};

SectionHeader.propTypes = {
  addMenuItems: PropTypes.arrayOf(PropTypes.node),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  moreMenuItems: PropTypes.arrayOf(PropTypes.node),
  rightColumnChildren: PropTypes.node,
  shouldShowAddMenu: PropTypes.bool,
  shouldShowMoreMenu: PropTypes.bool,
  testId: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default SectionHeader;
